export const toTitleCase = str => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
  }

  export function isEmptyObject(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  export function isNotEmptyObject(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        return true;
      }
    }
    return false;
  }

  export function checkObjectValuesAndIgnoreOne(obj, propToIgnore) {
    for (let key in obj) {
      if (key === propToIgnore) {
        continue; // ignore this property
      }
      if (!obj.hasOwnProperty(key) || obj[key] === null || obj[key] === undefined || obj[key] === '') {
        return false;
      }
    }
    return true;
  }

  export function checkObjectValuesAndIgnoreMultiple(obj, propsToIgnore) {
    for (let key in obj) {
      if (propsToIgnore.includes(key)) {
        continue; // ignore this property
      }
      if (!obj.hasOwnProperty(key) || obj[key] === null || obj[key] === undefined || obj[key] === '') {
        return false;
      }
    }
    return true;
  }

  
  export function formatJSON(jsonData) {
    const formattedData = { ...jsonData }; // Create a copy to avoid modifying original data
    formattedData?.data?.forEach(item => {
        item.serviceList = JSON.parse(item.serviceList);
        item.data = JSON.parse(item.data);
    });
    return formattedData;
}

export const sanitizeUserData =(userDataFromCookiesApiCall)=>{
    const obj = userDataFromCookiesApiCall[0];
    const token = obj?.token;
    const hasLogin = obj?.hasLogin === "1";
    const serviceList = obj?.serviceList;
    const user = obj?.data[0]
    const user_Id = obj?.user_Id

    return {serviceList, hasLogin, token, user_Id, user} 
}